import Request from './request'

const DeviceLocation = {
  getTrackGps (id, params, callback) {
    Request.post('device-location/track/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceLocation (id, callback) {
    Request.get('device-location/last/' + id).then(callback).catch(this.bad_answer)
  },
}
export default DeviceLocation
